import ActiveRecord from './active_record/base'

class EventType extends ActiveRecord {
	static tableName = 'eventTypes'
	static sort = 'name'
}

export default EventType
